const ArrowRight = ({ size=24, color="#12a87a", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2" 
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M5 12h14"/>
        <path d="m12 5 7 7-7 7"/>
    </svg>
);

export default ArrowRight;
